import { appEntry } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-lg border border-secondary-200/60 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <h3 className="text-xs tracking-widest uppercase text-primary-500 font-medium mb-2">Mobile Access</h3>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                {appEntry.title}
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5 max-w-lg">
                {appEntry.description}
              </p>
              <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
                {appEntry.features.map((f) => (
                  <span key={f} className="text-xs bg-secondary-100 text-secondary-700 px-3 py-1.5 rounded-full flex items-center gap-1.5 whitespace-nowrap">
                    <i className="ri-check-line text-accent-500 text-sm"></i>
                    {f}
                  </span>
                ))}
              </div>
            </div>

            <div className="shrink-0">
              <div className="w-40 h-40 bg-secondary-100 rounded-lg flex items-center justify-center border border-secondary-200/60 overflow-hidden">
                <img
                  src={appEntry.qrImage}
                  alt="扫码访问90影视移动端"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <p className="text-xs text-foreground-400 text-center mt-2">扫码即刻追剧</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}